module.exports = __webpack_public_path__ + "static/media/logo.b78f7015.png";